import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
const differences = ['+70 recursos en un solo lugar', 'Ahorrás miles de pesos frente a comprar cursos por separado', 'Pagás una vez y accedés para siempre', 'Desde Tarot hasta Biodecodificación', 'No solo aprendés: también recibís herramientas para monetizar tu conocimiento'];
export function DifferenceSection() {
  return <section className="py-12 bg-white" data-id="element-86">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-87">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-2xl md:text-3xl font-serif font-bold text-center text-black mb-8" data-id="element-88">
          Por qué este Pack no tiene competencia
        </motion.h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-89">
          {differences.map((diff, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className={`flex items-start gap-4 p-4 rounded-xl border ${index === differences.length - 1 ? 'md:col-span-2 bg-brown/5 border-brown/10' : 'bg-white border-gray-200'}`} data-id="element-90">
              <div className="w-6 h-6 rounded-full bg-terracotta/10 flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-91">
                <Check className="w-4 h-4 text-terracotta" data-id="element-92" />
              </div>
              <span className="text-gray-800 font-medium" data-id="element-93">{diff}</span>
            </motion.div>)}
        </div>
      </div>
    </section>;
}